// extracted by mini-css-extract-plugin
export const articles_container = "SingleArticleCard-module--articles_container--3lV78";
export const article = "SingleArticleCard-module--article--2a6Xu";
export const gradient = "SingleArticleCard-module--gradient--2xzpP";
export const bouncy = "SingleArticleCard-module--bouncy--3EeeD";
export const pop = "SingleArticleCard-module--pop--1RHrd";